import React, { ChangeEvent, FC, useCallback } from 'react'
import { useDebouncedCallback } from 'use-debounce/lib'
import { IFilterInputProps } from 'apps/fleet-planner/pages/loads/FilterFacilityLocation'
import { ILoadFilters } from 'apps/fleet-planner/types'
import { TextInput } from 'components/atoms'

interface IFilterReferenceNumberProps
  extends IFilterInputProps<Partial<Pick<ILoadFilters, 'referenceNumber'>>> {}

export const FilterReferenceNumber: FC<IFilterReferenceNumberProps> = ({
  dataTest = 'loads-filter-reference',
  label = 'Reference Number',
  onChange: onChangeProp,
  placeholder = 'Load ID, PO, etc.',
  value: valueProp,
}) => {
  const [onChangePropDebounced] = useDebouncedCallback(onChangeProp, 500)

  const changeHandler = useCallback(
    ({ target: { value: referenceNumber } }: ChangeEvent<HTMLInputElement>) => {
      onChangePropDebounced({ referenceNumber })
    },
    [onChangePropDebounced]
  )

  const { referenceNumber } = valueProp || {}

  return (
    <TextInput
      large
      placeholder={placeholder}
      label={label}
      onChange={changeHandler}
      value={referenceNumber}
      dataTest={dataTest}
    />
  )
}
